export const NET_WORK_ERROR = 'Network Error';
